module.exports = __webpack_public_path__ + "js/1.7455df29.worker.js"